"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpackProps = exports.mergePropsClassName = exports.mergeProps = void 0;
const arrayHelpers_1 = require("./arrayHelpers");
const mergeProps = (currentProps, newProps) => {
    const { className = '', style = {} } = currentProps, currentRest = __rest(currentProps, ["className", "style"]);
    const { className: newClassName = '', style: newStyle = {} } = newProps, newRest = __rest(newProps, ["className", "style"]);
    return Object.assign(Object.assign(Object.assign({}, currentRest), newRest), { className: (0, arrayHelpers_1.makeNonNullableArray)([className, newClassName]).join(' '), style: Object.assign(Object.assign({}, style), newStyle) });
};
exports.mergeProps = mergeProps;
const mergePropsClassName = (props, className) => {
    return Object.assign(Object.assign({}, props), { className: (0, arrayHelpers_1.makeNonNullableArray)([props === null || props === void 0 ? void 0 : props.className, className]).join(' ') });
};
exports.mergePropsClassName = mergePropsClassName;
const unpackProps = (props, propKeys) => {
    const rest = Object.assign({}, props);
    const unpacked = propKeys.reduce((result, key) => {
        delete rest[key];
        return Object.assign(Object.assign({}, result), { [key]: props[key] });
    }, {});
    return { rest: rest, unpacked };
};
exports.unpackProps = unpackProps;
